import { isBudgetManagerTagGroup } from '@domain/budget-manager/budget-manager.utils';
import { VIEW_TYPE } from '@shared/constants/dashboard/campaign-table-constants';
import { Segments, SelectedGroupWithSegments } from './segments.types';

export const maxElementsOnGraph = 4;

const isCampaignContentTypeSelected = (
    accountSelected, taggedCampaign,
) => accountSelected.content_type_name === taggedCampaign.platform;

const isValidCampaign = (taggedCampaign, campaigns) => taggedCampaign.campaign_id in campaigns;

const shouldInsertTag = (accountSelected, taggedCampaign, campaigns) => {
    if (!isValidCampaign(taggedCampaign, campaigns)) return false;
    if (!accountSelected.selected) return true;
    return isCampaignContentTypeSelected(accountSelected, taggedCampaign);
};

const insertTaggedCampaign = (reducedTags, taggedCampaign) => {
    const [tag] = taggedCampaign.tags;
    const campaignsIds = tag in reducedTags ? reducedTags[tag] : [];
    return {
        ...reducedTags,
        [tag]: [
            ...campaignsIds,
            { campaign_id: taggedCampaign.campaign_id, platform: taggedCampaign.platform },
        ],
    };
};

export const getTagsAndCampaignsByGroupSlug = (
    selectedGroup: SelectedGroupWithSegments,
    campaigns,
    accountSelected,
) => {
    if (slugIsCampaignType(selectedGroup)) {
        return formatTaggedCampaignsWhenIsCampaignType(
            selectedGroup, campaigns,
        );
    }

    const { taggedCampaigns = {} } = selectedGroup;
    const formattedTaggedCampaigns = Object.values(taggedCampaigns);

    return formattedTaggedCampaigns.reduce((acc, taggedCampaign) => {
        if (shouldInsertTag(accountSelected, taggedCampaign, campaigns)) {
            return insertTaggedCampaign(acc, taggedCampaign);
        }
        return acc;
    }, {});
};

// TODO - https://dev.azure.com/paretoio/paretech/_sprints/taskboard/Squad%20CCR/paretech/squad-ccr/Q3.S2?workitem=16546
// Fazer refatoração com middlaware para o campaigntype
const formatTaggedCampaignsWhenIsCampaignType = (selectedGroup, campaigns) => {
    const formattedCampaignsToArray = Object.values(campaigns);
    return formattedCampaignsToArray.reduce((acc, campaign) => {
        const { type } = campaign;
        const campaignsIds = type in acc ? acc[type] : [];
        return {
            ...acc,
            [type]: [
                ...campaignsIds,
                { campaign_id: campaign.campaign_id, platform: campaign.platform },
            ],
        };
    }, {});
};

export const slugIsCampaignType = ({ slug }) => slug === VIEW_TYPE.campaignType;

export const isStandardOrCampaignType = slug => slug === VIEW_TYPE.standard
    || slug === VIEW_TYPE.campaignType;

export const isTagGroupOrStandardType = slug => isBudgetManagerTagGroup(slug)
    || isStandardOrCampaignType(slug);

export const getGroupBySlug = (tagsGroups, groupSlug) => {
    const existingTagGroup = tagsGroups
        .find(tagGroup => tagGroup.slug === groupSlug);

    const newTagGroup = {
        id: 'new_group',
        name: '',
        isCreating: true,
    };

    return existingTagGroup || newTagGroup;
};

export const isTagGroupSelected = slug => slug !== VIEW_TYPE.standard;

export const convertSegmentPayload = segment => ({
    ...segment,
    taggedCampaigns: convertTaggedCampaignsToMap(segment),
});

export const convertTaggedCampaignsToMap = segment => segment?.['tagged_campaigns']?.reduce(
    (acc, campaign) => ({
        ...acc,
        [campaign.campaign_id]: campaign,
    }), {});

export const convertSegmentsTaggedCampaignsToMap = segments => segments.map((segment) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { tagged_campaigns: removedCampaigns, ...rest } = segment;
    return ({
        ...rest,
        taggedCampaigns: convertTaggedCampaignsToMap(segment),
    });
});

export const getTaggedCampaigns = (segment: Segments) => segment.taggedCampaigns;
